/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'

import { fieldExtraction } from '@/utils/index.utils'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        isDrawing: false,
        loading: false,
        breedWay: [],
        breedType: [],
        initAreaCode: [],
        planningTime: [],
        tempPlanningTime: [],
        importRecordTime: '',
        presentTime: [],
        presentInPlanningTime: [],
        forbidenInPlanningTime: [],
        limitInPlanningTime: [],
        allInPlanningTime: [],
        cityList: [],
        dictionary: [],
        compositeKeyToNameMap: {},
        keyToAreaNameMap: {}
    },
    mutations: {
        setIsDrawing(state, payload) {
            state.isDrawing = payload
        },
        setBreedWay(state, payload) {
            state.breedWay = payload
        },
        setBreedType(state, payload) {
            state.breedType = payload
        },
        setInitAreaCode(state, payload) {
            state.initAreaCode = payload
        },
        setPlanningTime(state, payload) {
            state.planningTime = payload
        },
        setPlanningTimeWithPlanType(state, payload) {
            state.tempPlanningTime = payload
        },
        setImportRecordTime(state, payload) {
            state.importRecordTime = payload
        },
        setPresentTime(state, payload) {
            state.presentTime = payload
        },
        setPresentInPlanningTime(state, payload) {
            const { type, data } = payload
            let key = ''
            switch (type) {
                case '禁养区':
                    key = 'forbidenInPlanningTime'
                    break
                case '限养区':
                    key = 'limitInPlanningTime'
                    break
                case '养殖区':
                    key = 'presentInPlanningTime'
                    break
                default:
                    key = 'allInPlanningTime'
                    break
            }
            state[key] = data
        },
        setCityList(state, payload) {
            state.cityList = payload
        },
        setDictionary(state, payload) {
            state.dictionary = payload
        },
        setCompositeKeyToNameMap(state, payload) {
            state.compositeKeyToNameMap = payload
        },
        setKeyToAreaNameMap(state, payload) {
            state.keyToAreaNameMap = payload
        }
    },
    actions: {
        async getAreaAction({ commit }) {
            const result = await $http.Area({
                data: {
                    pageIndex: 1,
                    pageSize: 0
                }
            })

            const keyToAreaNameMap = {}
            result.data.data.forEach(v => {
                const key = v.areaCode
                keyToAreaNameMap[key] = {
                    ...v
                }
            })

            commit('setKeyToAreaNameMap', keyToAreaNameMap)
        },
        async getDictionary({ commit }, payload) {
            const [userRole] = payload.userRole
            const result = await $http.EnumTree({
                data: {}
            })

            const [groupedOptions, compositeKeyToNameMap] = fieldExtraction(result.data.data, userRole)

            // const dictionary = _.groupBy(groupResult, 'parentId')
            commit('setCompositeKeyToNameMap', compositeKeyToNameMap)
            commit('setDictionary', groupedOptions)
        },
        getBreedWay({ commit }) {
            $http.BreedWay().then(res => {
                commit('setBreedWay', res.data.data)
            })
        },
        getBreedType({ commit }) {
            $http.BreedType().then(res => {
                commit('setBreedType', res.data.data)
            })
        },
        getInitAreaCode({ commit }) {
            return new Promise((resolve, reject) => {
                $http
                    .Area({
                        params: {
                            areaCode: '350000'
                        }
                    })
                    .then(res => {
                        const areaOptions = res.data.data.map(item => {
                            return {
                                label: item.areaName,
                                value: item.areaCode,
                                isLeaf: false,
                                ...item
                            }
                        })
                        commit('setInitAreaCode', areaOptions)

                        resolve(areaOptions)
                    })
            })
        },
        getPlanningTime({ state, commit }) {
            if (!state.planningTime.length) {
                return new Promise((resolve, reject) => {
                    $http.PlanningTime({}).then(res => {
                        resolve(res.data.data)
                            // commit('setPlanningTime', res.data.data)
                    })
                })
            }
        },
        getPlanningTimeByPlanType({ state, commit }, payload) {
            return new Promise((resolve, reject) => {
                $http
                    .PlanningTimeByType({
                        data: {
                            pageIndex: 1,
                            pageSize: -1,
                            request: {
                                importType: 0,
                                planningType: payload.planningType
                            }
                        }
                    })
                    .then(res => {
                        const filterData = res.data.data.filter(v => v.importSuccess)
                        console.log(filterData, 'filterData')
                        commit('setPlanningTimeWithPlanType', filterData)
                        resolve(filterData)
                    })
            })
        },
        getImportRecordTime({ state, commit }, payload) {
            return new Promise((resolve, reject) => {
                $http
                    .GetTmportRecordTime({
                        params: {
                            'planningType': payload.type
                        }
                    })
                    .then(res => {
                        console.log(res.data.data, 'res')
                        commit('setImportRecordTime', res.data.data)
                        resolve(res.data)
                    })
            })
        },
        getPresentTime({ state, commit }) {
            if (!state.presentTime.length) {
                return new Promise((resolve, reject) => {
                    $http
                        .PresentTime({
                            params: { dataType: 1 }
                        })
                        .then(res => {
                            resolve(res.data.data)
                        })
                })
            }
        },
        getPresentInPlanningTime({ state, commit }, payload) {
            const { type, allYear, recordId } = payload
            let stateData = null
            switch (payload) {
                case '禁养区':
                    stateData = state.forbidenInPlanningTime
                    break
                case '限养区':
                    stateData = state.limitInPlanningTime
                    break
                case '养殖区':
                    stateData = state.presentInPlanningTime
                    break
                default:
                    stateData = state.allInPlanningTime
                    break
            }
            if (!(stateData || []).length) {
                return new Promise((resolve, reject) => {
                    $http
                        .PresentInPlanningTime({
                            params: {
                                planningType: type || '禁养区',
                                allYear,
                                recordId
                            }
                        })
                        .then(res => {
                            resolve(res.data.data)
                        })
                })
            }
        }
    },
    modules: {},
    getters: {
        userFrontMenus(state, getters) {
            const frontMenus = getters['core/frontMenus'] || []
            return frontMenus.filter(v => !v.parentId)
                // 找到前端菜单
                // const frontFolderMenuId = (frontMenus.find(m => getMenuConfig(m).type === 'folder') || {})
                //   .menuId
                // if (!frontFolderMenuId) {
                //   return []
                // }
                // return frontMenus.filter(v => v.parentId === frontFolderMenuId)
        }
    }
})